module.exports = __webpack_public_path__ + "static/img/point-bg.f32485a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/point-bg.png
// module id = FyuI
// module chunks = 0